import { APIEntity, registerEntity } from '../APIEntity';
import { DockPointerData } from '../models/DockPointer';

/**
 * DeckTemplate entity — backed by a DeckTemplateRecord on disk
 * (<project>/agentic-assets/deck_template/<name>/), built + generated by the `decker`
 * skill.
 *
 * Folder layout:
 *   <name>/template.json          — {metadata:{title,description,page_types}, data:{}}
 *   <name>/layouts/<layout>.html  — one isolated slide-layout component each
 *   <name>/common/tokens.css      — design tokens (re-skin surface)
 *   <name>/common/theme.css       — layout-agnostic base (replaces Reveal theme)
 *   <name>/vendor/reveal/         — vendored headless Reveal runtime
 *
 * The container is the entity; layouts are read on demand. `asset_ref` is the
 * folder path (mirrors CHART/DATASET), so the DeckTemplateViewer reads
 * `layouts/*.html` + `common/*.css` off it via FSRef.
 */
@registerEntity
export class DeckTemplate extends APIEntity<DeckTemplate> {
  static type: string = 'deck_template';
  static override icon = 'Presentation';

  description: string = '';
  asset_ref?: string;
  layouts?: string[];
  page_types?: string[];
  num_layouts?: number;

  constructor(entity: Partial<DeckTemplate> = {}) {
    super(entity);
    this.description = entity.description ?? '';
    this.asset_ref = entity.asset_ref;
    this.layouts = entity.layouts;
    this.page_types = entity.page_types;
    this.num_layouts = entity.num_layouts;
  }

  /** Default open target: the deck-template gallery viewer (URL-first target). */
  override get dockPointer(): DockPointerData {
    return this.assetEditorPointer() ?? this.defaultDockPointer;
  }

  override get editorDockPointer(): DockPointerData {
    return this.assetEditorPointer() ?? super.editorDockPointer;
  }

}
